<template>
  <div class="master-space">
    <h1 class="title1">专家论坛</h1>
    <div style="width:80%;margin-left:15%;">
      <el-row :gutter="20">
        <el-col :span="7">
          <div>
            <img :src="masterShow.path" alt="" width="372" height="457">
          </div>
        </el-col>
        <el-col :span="5">
          <div>
            <h2 class="highLight" @click="checkKnowledge(newsID)">{{masterShow.title}}</h2>
            <div style="width:100%;">时间：{{masterShow.time}}</div>
            <div style="width:100%;margin-top:10px;">{{masterShow.content}}</div>
            <el-button style="margin-top:15px;" @click="moreKnowlege">查看更多&nbsp;&nbsp;<span class="el-icon-right"></span>
            </el-button>
          </div>
        </el-col>
        <el-col :span="9">
          <div >
            <div v-for="(itemMS,index) in masterItems" :key="index" class="his-items" @click="checkKnowledge(itemMS)">
              <div class="his-img">
                <img :src="itemMS.path" width="130" height="95" alt="">
              </div>
              <div class="his-topic">
                <div style="font-size:16px;"><span class="highLight">{{itemMS.title}}</span></div>
                <div>发布时间： {{itemMS.time}} </div>
                <div> {{itemMS.content}} </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { homeOpinion } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      masterSpaceArr: [
        {
          path: '../../../../static/img/masterSpace/list1.png',
          index: 1,
          content:
            '主要介绍物联网的发展历史与相关技术。从物联网的全面感知，可靠传输到数据的只能处理...',
          time: '209-05-20',
          title1: '第三期#',
          title2: '物联网与智慧农业'
        },
        {
          path: '../../../../static/img/masterSpace/list2.png',
          index: 2,
          content:
            '主要介绍物联网的发展历史与相关技术。从物联网的全面感知，可靠传输到数据的只能处理...',
          time: '209-05-20',
          title1: '第4期#',
          title2: '物联网与智慧农业'
        },
        {
          path: '../../../static/img/masterSpace/list3.png',
          index: 3,
          content:
            '主要介绍物联网的发展历史与相关技术。从物联网的全面感知，可靠传输到数据的只能处理...',
          time: '209-05-20',
          title1: '第5期#',
          title2: '物联网与智慧农业'
        },
        {
          path: '../../../static/img/masterSpace/list4.png',
          index: 4,
          content:
            '主要介绍物联网的发展历史与相关技术。从物联网的全面感知，可靠传输到数据的只能处理...',
          time: '209-05-20',
          title1: '第6期#',
          title2: '物联网与智慧农业'
        }
      ],
      masterItems: [],
      masterShow: null
    };
  },
  created() {
    // this.knowledgeList();
  },
  methods: {
    checkKnowledge(newsObj) {
      this.$router.push({ name: 'knowledge', params: newsObj });
    },
    moreKnowlege() {
      this.$router.push({ name: 'knowledge' });
    },
    knowledgeList() {
      let knowSelf = this;
      homeOpinion({ newsType: 10, count: 5 }).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          let tempMAObj = {
            path: '',
            title: '',
            time: '',
            newsId: '',
            content: '',
            author: ''
          };
          tempMAObj.path = res.data[i].newsMainImg;
          tempMAObj.title = res.data[i].newsTitle;
          tempMAObj.time = res.data[i].newsUpdateTime;
          tempMAObj.newsId = res.data[i].newsId;
          tempMAObj.content =
            ' 第四期《国务院关于加快推进农村机械化和农机装备产业升级.....》';
          // tempMAObj.content = res.data[i].newsSummary;
          tempMAObj.author = res.data[i].newsAuthor;
          knowSelf.masterItems.push(tempMAObj);
        }
        knowSelf.masterShow = knowSelf.masterItems[0];
        knowSelf.masterItems.shift();
      });
    }
  }
};
</script>
<style scoped>
.master-space {
  padding: 10px 0;
}
h4 {
  cursor: pointer;
  width: 100%;
}
.news-module {
  overflow: hidden;
  margin: 10px auto;
  padding-left: 16%;
}
.news-module-img {
  width: 24%;
}
.news-module div {
  float: left;
  font-size: 18px;
  margin-left: 1%;
}
.title1 {
  width: 100%;
  text-align: center;
}
.his-seanson {
  width: 27%;
}

.his-items {
  overflow: hidden;
  height: 110px;
  width: 100%;
  margin-bottom: 10px;
}
.his-seanson div {
  cursor: pointer;
}

.his-img {
  float: left;
  width: 26%;
  margin-right: 4%;
}
.his-topic {
  float: left;
  width: 68%;
  overflow: hidden;
}
.his-topic div {
  width: 100%;
  margin-bottom: 8px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/homeMaster.vue